import classNames from "classnames";
import Button from "../../custom/button/button";
import styles from "./main.module.scss";
import { baseUrl } from "../../requests";
import { useAtomValue } from "jotai";
import { conferencePayment, userData } from "../../state";
import { formatCurrency } from "../../utils/formatCurrency";
import usePayment from "../../hooks/usePayment";

const PayForConference = ({
  amount,
  dataId,
  hasUserRegistered,
}: {
  hasUserRegistered?: boolean;
  amount: number;
  dataId: number;
}) => {
  const { makePayment, isPending } = usePayment();
  const user = useAtomValue(userData);
  const conferencePaymentDetails = useAtomValue(conferencePayment);

  const handlePayment = async () => {
    const payload: ProcessPaymentPayload = {
      RouteId: user?.MembershipTypeId!,
      MembershipNo: user?.MemberId!,
      Amount: amount || conferencePaymentDetails?.Amount,
      Description: "Conference Payment",
      ReturnURL: `${baseUrl}/event-application/conferences`,
      PaymentForm: "Conference",
      DataId: dataId ? `${dataId}` : conferencePaymentDetails?.DataId,
    };
    makePayment(payload, (data) => {
      const responseData = JSON.parse(data?.ResponsePayLoad) as PaymentDetails;
      //window.open(responseData?.RedirectURL, "_blank");
      window.location.href = responseData?.RedirectURL;
    });
  };

  return (
    <section className={classNames("card")}>
      <h2>Pay for Conference</h2>
      <div className={styles.line}></div>
      {hasUserRegistered ? (
        <p>
          Looks like you've registered for this event but have not completed
          payment. Proceed to pay{" "}
          <b>
            {amount
              ? formatCurrency(amount)
              : formatCurrency(conferencePaymentDetails?.Amount)}
          </b>{" "}
          before the event date.
        </p>
      ) : (
        <p>
          You are one step away to complete your conference registration.
          Proceed to pay{" "}
          <b>
            {amount
              ? formatCurrency(amount)
              : formatCurrency(conferencePaymentDetails?.Amount)}
          </b>{" "}
          before the event date.
        </p>
      )}
      <br />

      <Button
        type="button"
        isLoading={isPending}
        disabled={isPending}
        onClick={handlePayment}
        text="Make Payment"
      />
    </section>
  );
};

export default PayForConference;
